<template>
  <div class="docs-page">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered -adjust-content-up">
          <img
            src="../assets/img/illustrations/03.png"
            class="-image has-margin-bottom-20"
          />
          <h1 class="title has-margin-bottom-40">Almost Ready!</h1>
          <p class="subtitle">
            When things settle down, we'll publish our complete documentation
            here. <router-link to="/contact">Reach out</router-link> if you have
            questions in the meantime.
          </p>
          <router-link to="/contact">
            <b-button type="is-primary" icon-left="email">
              Contact Us
            </b-button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "docsPage"
};
</script>

<style scoped lang="scss">
.-image {
  max-height: 256px;
  width: auto;
}

@media only screen and (max-width: 600px) {
  .-image {
    max-height: 192px;
    width: auto;
  }
}

.-adjust-content-up {
  margin-top: -120px;
}
</style>
